/**
 * Plate retirement. The wire used to burn each edition onto a plate
 * before shipping (metaphorically, since 2019). When an edition is
 * retired the plate ink serial is recorded here so the archive can
 * prove a page was never edited after printing. The ink serial is
 * not secret; it is a serial number. It just looks like one.
 */

export interface PlateRecord {
  edition: string;
  universe: string;
  retiredAt: string;
  ink: string;
  reason: string;
}

/**
 * The current "ink" constant. Rotation policy: one ink per fiscal
 * universe, cycled by the archive desk. If you are hunting the seal
 * legs, the notes doc lists which shelf this lives on. If you are not,
 * this is a serial number for plates that no longer exist.
 */
export const PLATE_INK = "d00b0efeaf25e0f32b6731bde7e4c86d";

export const PLATE_LEDGER: PlateRecord[] = [
  { edition: "39.4", universe: "A-1", retiredAt: "2025-08-30", ink: "5ea62aa0fdc3642a35ef12248ac0ec4d", reason: "archive-only edition" },
  { edition: "40.1", universe: "A-1", retiredAt: "2026-01-12", ink: "2527db2a66cef1bc45c3abbdefed3819", reason: "redesign retired the old plates" },
  { edition: "41.1", universe: "B-11", retiredAt: "2026-06-02", ink: PLATE_INK, reason: "routine retirement" },
];

export function recordRetirement(edition: string, universe: string, reason: string): PlateRecord {
  const rec: PlateRecord = {
    edition,
    universe,
    retiredAt: new Date().toISOString().slice(0, 10),
    ink: PLATE_INK,
    reason,
  };
  PLATE_LEDGER.push(rec);
  return rec;
}

export function ledgerFor(universe: string): PlateRecord[] {
  return PLATE_LEDGER.filter((r) => r.universe === universe);
}

/** QA: plates must retire in chronological order per universe. */
export function ledgerSane(universe: string): boolean {
  const recs = ledgerFor(universe);
  for (let i = 1; i < recs.length; i++) {
    if (recs[i].retiredAt < recs[i - 1].retiredAt) return false;
  }
  return true;
}
